import { withAuthRecovery } from '@/lib/authRecovery'
import { getSupabase } from '@/lib/supabase'
import type { StudioSubscriptionType } from '@/types'

// Модель продаж студии задаёт условие договора (20261020190000): сервер сам ведёт
// studio_subscription_settings по условию на дату. Здесь — только ручная отметка вне правила
// (Вологда 599/642, студия УК 216): ставит и снимает advanced, с причиной.

export type StudioSubscriptionModelSource = 'CONTRACT' | 'MANUAL'

export type StudioSubscriptionModelRow = {
  studio_internal_id: number
  studio_number: number | null
  city_name: string | null
  status_code: string | null
  subscription_type: StudioSubscriptionType | null
  subscription_type_source: StudioSubscriptionModelSource | null
  subscription_type_manual_reason: string | null
  subscription_type_manual_at: string | null
  contract_sales_model: StudioSubscriptionType | null
  contract_term_id: number | null
  contract_term_from: string | null
  first_subscription_sale_date: string | null
  first_sale_date_source: 'LISTOK' | 'MANUAL' | null
}

export type StudioSubscriptionHistoryRow = {
  old_subscription_type: StudioSubscriptionType | null
  new_subscription_type: StudioSubscriptionType | null
  changed_at: string | null
  changed_by: string | null
}

export async function fetchStudioSubscriptionModels(): Promise<StudioSubscriptionModelRow[]> {
  const { data, error } = (await withAuthRecovery(() =>
    (getSupabase() as any).rpc('list_studio_subscription_models')
  )) as { data: StudioSubscriptionModelRow[] | null; error: any }

  if (error) throw error
  return data ?? []
}

export async function fetchStudioSubscriptionHistory(studioNumber: number): Promise<StudioSubscriptionHistoryRow[]> {
  const { data, error } = (await withAuthRecovery(() =>
    (getSupabase() as any).rpc('get_studio_subscription_transition_context', {
      v_studio_number: studioNumber,
    })
  )) as { data: StudioSubscriptionHistoryRow[] | null; error: any }

  if (error) throw error
  return data ?? []
}

export async function setStudioSubscriptionModelManual(params: {
  studioInternalId: number
  subscriptionType: StudioSubscriptionType
  reason: string
}): Promise<void> {
  const { error } = (await withAuthRecovery(() =>
    (getSupabase() as any).rpc('set_studio_subscription_model_manual', {
      p_studio_internal_id: params.studioInternalId,
      p_subscription_type: params.subscriptionType,
      p_reason: params.reason,
    })
  )) as { error: any }

  if (error) throw error
}

export async function clearStudioSubscriptionModelManual(studioInternalId: number): Promise<void> {
  const { error } = (await withAuthRecovery(() =>
    (getSupabase() as any).rpc('clear_studio_subscription_model_manual', {
      p_studio_internal_id: studioInternalId,
    })
  )) as { error: any }

  if (error) throw error
}
